import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

document.addEventListener("turbo:load", () => {
  const main = document.querySelector('main');
  if (main) {
    document.querySelector(':root').style.setProperty(
      '--scrollbar-width',
      `${main.offsetWidth - main.clientWidth}px`
    );
  }
})

export { application }
